<template>
  <v-row id="notificationPendingRates" column fill-height>
    <v-list three-line dense>
      <v-subheader>{{ resx.labels.pendingScoreVisitsTitle }}</v-subheader>
      <v-list-item
        v-for="item in items"
        :key="item._id"
        @click="rateVisit(item)"
        ripple
      >
        <v-list-item-content>
          <v-list-item-title>{{
            item.contractorCompany.contractor.name
          }}</v-list-item-title>
          <v-list-item-subtitle>{{
            item.contractorCompany.type.name
          }}</v-list-item-subtitle>
          <v-list-item-subtitle>{{
            timeFromNow(item.dateOfVisit)
          }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-btn id="viewAll" :to="{ name: 'history' }" block small color="primary">{{
      resx.labels.viewAll
    }}</v-btn>
  </v-row>
</template>

<script>
import moment from "moment";

export default {
  name: "notificationPendingRates",
  methods: {
    timeFromNow(dateTime) {
      return moment(dateTime).fromNow();
    },
    rateVisit(visit) {
      this.$emit("selectVisit", visit);
    }
  },
  props: {
    items: { type: Array }
  }
};
</script>

<style lang="scss">
#notificationPendingRates {
  #viewAll {
    margin-bottom: 0;
    margin-top: 0;
  }

  .v-list--dense .v-subheader {
    font-size: 1rem;
  }

  display: contents;
}
</style>
